export enum PoolTransactionsTab {
  ALL_ACTIVITY = 'allActivity',
  USER_ACTIVITY = 'userActivity',
  TRADES = 'trades',
  SWAPS = 'swaps',
}
